import { i18n } from "../../../setup/i18n-setup";

export default {
  pages: {
    key: "title",
    data: [
      {
        title: i18n.t('sections.home.title'),
        url: '/',
        icon: 'HomeIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('sections.live-schedule.title')}`,
        url: '/student/liveschedule',
        icon: 'MailIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('sections.pm.title')}`,
        url: '/pm',
        icon: 'MailIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('profile.profile-info.title')}`,
        url: '/profile',
        icon: 'UserIcon', is_bookmarked: false
      },
    ]
  }
}
